'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import text from 'I18n/utils/unescapedText';
import { getTab, makeGetTabAsset } from 'DesignData/selectors/tabs';
import * as TabsActions from 'DesignData/actions/Tabs';
import { TEMPLATE, LAYOUT, LAYOUT_SOURCE, GLOBAL_GROUP, CUSTOM_WIDGET, SETTINGS, WELCOME, GETTING_STARTED } from 'DesignData/enums/DesignAssetTypes';

const i18nKey = key => `designManager.tabs.${key}`;

function getLabel(tab, tabAsset) {
  if (tab.assetType === SETTINGS) {
    const {
      settingsCategory
    } = tab.editorOptions;
    return text(`designManager.settings.categories.${settingsCategory}.title`);
  }

  if (tab.assetType === WELCOME) {
    return text('designManager.welcome.title');
  }

  if (tab.assetType === GETTING_STARTED) {
    return text('designManager.gettingStarted.tabTitle');
  }

  if (!tabAsset) return tab.label;
  const {
    label
  } = tabAsset;

  switch (tab.assetType) {
    case CUSTOM_WIDGET:
      return tabAsset.name;

    case LAYOUT:
    case LAYOUT_SOURCE:
    case GLOBAL_GROUP:
      {
        return tab.assetType === LAYOUT_SOURCE ? text(i18nKey('viewSourceLabel'), {
          label
        }) : label;
      }

    case TEMPLATE:
      {
        return tabAsset.generatedFromLayoutId ? text(i18nKey('viewSourceLabel'), {
          label
        }) : label;
      }

    default:
      return label;
  }
}

function makeMapStateToProps() {
  const getTabAsset = makeGetTabAsset();
  return function mapStateToProps(state, props) {
    const tab = getTab(state, props) || {};
    const {
      id: assetId,
      assetType
    } = tab;
    const tabAsset = getTabAsset(state, {
      assetId,
      assetType
    });
    return {
      tab,
      label: getLabel(tab, tabAsset)
    };
  };
}

const mapDispatchToProps = {
  openTab: TabsActions.openTab
};
export default function withConnectedTabLabel(WrappedComponent) {
  class HighOrderConnectedTabLabel extends Component {
    constructor(...args) {
      super(...args);

      this.openTab = () => {
        const {
          tab,
          openTab
        } = this.props; // TODO: Bad tab values crashes. Use file or asset object instead.

        openTab(tab);
      };
    }

    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        openTab: this.openTab
      }));
    }

  }

  HighOrderConnectedTabLabel.propTypes = {
    tab: PropTypes.object,
    openTab: PropTypes.func.isRequired,
    label: PropTypes.string
  };
  HighOrderConnectedTabLabel.defaultProps = {
    label: ''
  };
  return connect(makeMapStateToProps, mapDispatchToProps)(HighOrderConnectedTabLabel);
}